import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";
import logo from "../img/brand.png";
import premiumLogo from "../img/premiumBrandPink.png";
import mobileLogo from "../img/mobileBrand.png";
import premiumMobileLogo from "../img/premiumMobileBrandPink.png";
import portalLogo from "../../../shared/general/img/hhPortalLogo.png";
import partnerNetworkLogo from "../img/partnerNetworkBrand.png";

export const BrandWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
`;

export const PremiumBrand = styled.div`
  height: 30px;
  width: 140px;
  background-image: url(${premiumLogo});
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0 15px;

  ${mediaMaxWidth.tablet`
    height: 50px;
    width: 55px;
    background-image: url(${premiumMobileLogo});
    margin: 0;
    position: absolute;
    top: 5px;
    left: 10px;
  `}
`;

export const Brand = styled.div`
  height: 50px;
  width: 175px;
  background-image: url(${logo});
  background-size: cover;
  background-repeat: no-repeat;

  ${mediaMaxWidth.tablet`
    width: 50px;
    background-image: url(${mobileLogo});
    position: absolute;
    top: 5px;
    left: 10px;
  `}
`;

export const PortalBrand = styled.div`
  height: 40px;
  width: 185px;
  background-image: url(${portalLogo});
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  left: 10px;

  ${mediaMaxWidth.tablet`
    width: 110px;
    height: 24px;
    position: absolute;
    top: 19px;
    left: 10px;
  `}

  ${mediaMaxWidth.smallPhone`
    width: 70px;
    height: 15px;
    top: 24px;
  `}
`;

export const PartnerNetworkBrand = styled.div`
  height: 40px;
  width: 220px;
  background-image: url(${partnerNetworkLogo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 10px 0;

  ${mediaMaxWidth.tablet`
    width: 110px;
    height: 24px;
    position: absolute;
    top: 19px;
    left: 10px;
    background-position: initial;
  `}

  ${mediaMaxWidth.smallPhone`
    width: 70px;
    height: 15px;
    top: 24px;
  `}
`;
